// extracted by mini-css-extract-plugin
module.exports = {"container":"sidebarStyle-module--container--mlBB-","filtersTitle":"sidebarStyle-module--filtersTitle--ngEsV"};